"use client";

// Stamps `data-shell="desktop"` on <html> when running inside the innernet Mac
// app, so globals.css can inset the top bar under the traffic lights and make
// the chrome a window-drag region. No-op in a normal browser.

import { useEffect } from "react";
import { isDesktopShell } from "../lib/desktop";

export default function DesktopShellFlag() {
  useEffect(() => {
    if (isDesktopShell()) document.documentElement.dataset.shell = "desktop";
  }, []);
  return null;
}
